import React, { Fragment, useState, FC } from 'react';
import { useShop } from '../../stores/ShopStore';
import { useObserver } from 'mobx-react-lite';
import { ViewState } from '../../domain/models/ViewState';
import { LayoutVariant } from '../Core/CommonTypes';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import {
  withWidth,
  isWidthUp,
  ThemeProvider,
  createMuiTheme,
  responsiveFontSizes
} from '@material-ui/core';
import { teal, deepOrange } from '@material-ui/core/colors';
import SubmitShopOrder from './SubmitShopOrder';
import ShopOrderingPage from './ShopOrderingPage';
import { LocaleConfigProvider } from '../../stores/LocaleConfigProvider';

interface WithWidthShopPageProps {
  width: Breakpoint;
}

export default withWidth()(({ width }: WithWidthShopPageProps) => {
  const variant = isWidthUp('md', width)
    ? LayoutVariant.laptop
    : LayoutVariant.mobile;

  return <ShopPage variant={variant} />;
});

interface ShopPageProps {
  variant?: LayoutVariant;
}

const ShopPage: FC<ShopPageProps> = ({ variant }: ShopPageProps) => {
  const shopStore = useShop();
  const [showSubmitOrderDialog, setShowSubmitOrderDialog] = useState(false);
  const [showOrderDetail, setShowOrderDetail] = useState(false);

  const handleSubmitOrderClose = () => {
    setShowSubmitOrderDialog(false);
    if (
      variant === LayoutVariant.mobile &&
      shopStore.submitState === ViewState.OK
    ) {
      setShowOrderDetail(false);
    }
    // Reset the submitting state
    shopStore.submitState = ViewState.NONE;
  };

  let theme = createMuiTheme({
    palette: {
      primary: teal,
      secondary: deepOrange,
      type: 'dark',
      common: {
        black: '#465563'
      }
    }
  });
  theme = responsiveFontSizes(theme);

  return useObserver(() => (
    <ThemeProvider theme={theme}>
      <LocaleConfigProvider locale={{ locale: 'point' }}>
        <Fragment>
          <ShopOrderingPage
            variant={variant}
            onSubmit={() => setShowSubmitOrderDialog(true)}
            showOrderDetail={showOrderDetail}
            setShowOrderDetail={setShowOrderDetail}
          />
          {showSubmitOrderDialog && (
            <SubmitShopOrder
              onClose={handleSubmitOrderClose}
              variant={variant}
            />
          )}
        </Fragment>
      </LocaleConfigProvider>
    </ThemeProvider>
  ));
};
